import { render, staticRenderFns } from "./OurBidDetails.vue?vue&type=template&id=72bca495&"
import script from "./OurBidDetails.vue?vue&type=script&lang=js&"
export * from "./OurBidDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports